import React from "react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@gettactic/components/src/primitives/Popover/Popover";
import { InformationCircleIcon } from "@heroicons/react/outline";
import { ReserveFormUsers } from "@/features/reserve/components/Reserve/controls/ReserveFormUsers";
import { ReserveFormOrganizer } from "@/features/reserve/components/Reserve/controls/ReserveFormOrganizer";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";

export const ReserveFormAdminReservation: React.FC = () => {
  const { enableAdminReservation, isMeetingRoom } = useReserveForm();
  if (!enableAdminReservation) return null;

  return (
    <div className="mt-2 text-neutral-500">
      {!isMeetingRoom ? (
        <>
          <div className="flex items-center">
            <span className={styles.Label}>User</span>
            <Popover>
              <PopoverTrigger asChild>
                <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-neutral-400" />
              </PopoverTrigger>
              <PopoverContent side="top" className="z-20 w-[250px]">
                <span>
                  As an admin or scheduler, you can make reservation on behalf
                  of other users.
                </span>
              </PopoverContent>
            </Popover>
          </div>
          <ReserveFormUsers />
        </>
      ) : (
        <>
          <div className="flex items-center">
            <span className={styles.Label}>Organizer</span>
            <Popover>
              <PopoverTrigger asChild>
                <InformationCircleIcon className="ml-2 h-5 w-5 cursor-pointer text-neutral-400" />
              </PopoverTrigger>
              <PopoverContent side="top" className="z-20 w-[300px]">
                <span>
                  Select an organizer for the meeting. As you are creating this
                  reservation on behalf of another user, you will not be the
                  organizer, nor one of the invitees.
                </span>
              </PopoverContent>
            </Popover>
          </div>
          <ReserveFormOrganizer />
        </>
      )}
      <div className="relative pb-4">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-neutral-300 border-t" />
        </div>
      </div>
    </div>
  );
};

const styles = {
  Label:
    "text-secondary-foreground font-inter font-normal text-sm leading-none tracking-normal"
};
